export default "__VITE_ASSET__BlUYI_yC__"